import React from "react";
import DeleteSVG from "../../../components/svg/DeleteSVG";
import EditSVG from "../../../components/svg/EditSVG";

export default function AssignmentListTr({ row, handleDelete }) {
  const { id, title, video_title, totalMark } = row || {};
  return (
    <tr>
      <td className="table-td">{title}</td>
      <td className="table-td">{video_title}</td>
      <td className="table-td">{totalMark}</td>
      <td className="table-td flex gap-x-2">
        <DeleteSVG onClick={() => handleDelete(id)} />
        <EditSVG to={`/admin/editAssignment/${id}`} />
      </td>
    </tr>
  );
}
